var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 9.09967V11.8997C10.6667 14.233 9.73337 15.1663 7.40004 15.1663H4.60004C2.26671 15.1663 1.33337 14.233 1.33337 11.8997V9.09967C1.33337 6.76634 2.26671 5.83301 4.60004 5.83301H7.40004C9.73337 5.83301 10.6667 6.76634 10.6667 9.09967Z",
    stroke: "#2C53F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.09967V7.89967C14.6667 10.233 13.7334 11.1663 11.4 11.1663H10.6667V9.09967C10.6667 6.76634 9.73337 5.83301 7.40004 5.83301H5.33337V5.09967C5.33337 2.76634 6.26671 1.83301 8.60004 1.83301H11.4C13.7334 1.83301 14.6667 2.76634 14.6667 5.09967Z",
    stroke: "#2C53F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5ce542b22010e8a28137c0b887c2db7a.svg";
export { ForwardRef as ReactComponent };